module.exports = __webpack_public_path__ + "img/logo-idtrust.93d3d99a.svg";